
import React from "react";
import HeroSection from "@/components/HeroSection";
import HomepageSchema from "@/components/SEO/HomepageSchema";
import MorningMagicSection from "@/components/sections/MorningMagicSection";
import CraftLettersSection from "@/components/sections/CraftLettersSection";
import TransformMorningsSection from "@/components/sections/TransformMorningsSection";
import MagicJourneySection from "@/components/sections/MagicJourneySection";
import BlogPreviewSection from "@/components/sections/BlogPreviewSection";
import SeasonalResources from "@/components/sections/SeasonalResources";
import LetterExamples from "@/components/funnel/LetterExamples";
import EmergencyGuideLinks from "@/components/letters/EmergencyGuideLinks";

const Index = () => {
  return (
    <>
      <HomepageSchema />
      <div>
        <HeroSection />
        <SeasonalResources />
        <div className="container mx-auto px-4"><EmergencyGuideLinks /><LetterExamples source="home" /></div>
        <MorningMagicSection />
        <CraftLettersSection />
        <TransformMorningsSection />
        <MagicJourneySection />
        <BlogPreviewSection />
      </div>
    </>
  );
};

export default Index;
